<template>
  <div>
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
        <el-form-item :label="$t('mail.type')" prop="type">
          <el-select v-model="filters.type" class="w100" :placeholder="$t('index.pleaseInput')">
            <el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in MAIL_TYPE" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="init">{{$t('index.query')}}</el-button>
          <el-button type="" size="mini" @click="reset">{{$t('index.reset')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" v-if="hasBtn('add')" @click="add('')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="title" align="center" :label="$t('mail.title')"></el-table-column>
      <el-table-column prop="total" align="center" :label="$t('index.operation')">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button type="info" size="mini" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="$t('index.dialog_title')" width="900px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('mail.title')" prop="title">
              <el-input v-model="editForm.title" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('mail.type')" prop="type">
              <el-select v-model="editForm.type" class="w100" :placeholder="$t('index.pleaseInput')">
                <el-option v-for="(item,index) in MAIL_TYPE" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="String(item.code)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('news_index.content')" prop="content">
              <editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import EditorBar from '../../components/wangEnduit.vue'
export default {
	components: {
		// EditorBar
	},
	data() {
		return {
			MAIL_TYPE: [],
			isClear: false,
			editFormVisible: false,
			editForm: {},
			filters:{
				type:'',
			},
			list: [],
			id: '',
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			editFormRules: {

			}
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: "MAIL_TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.MAIL_TYPE = res.MAIL_TYPE;
				this_.init();
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "emailTmpList";
			var datas = {
				type:this_.filters.type,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res;
				// this_.pages.count = res.sum;
			})
		},
		reset(){
			this.filters.type='';
			this.init();
		},
		add(data) {
			var this_ = this;
			if (data) {
				this_.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this_.editForm = {
					title: '',
					title_cn: '',
					content: '',
					type: '',
					is_default: '',
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title: this_.editForm.title,
						type: this_.editForm.type,
						content: this_.editForm.content,
					}
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
					}
					var url = "emailTmpAction";
					var tishi = this_.$t('index.add_success');
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		del(data) {
			var this_ = this;
			var url = "emailTmpDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},


	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.transaction_id {
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/mail/index.vue